module.exports = __webpack_public_path__ + "static/img/Receive2.296fa92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Receive2.png
// module id = XPeX
// module chunks = 0